
import React from 'react';
import { Settings } from 'lucide-react';
import KitTemplate from '@/components/hq/KitTemplate';

const TechnologyKit = () => {
  const sections = {
    downloads: {
      title: "🔹 Downloads",
      description: "Software setup guides and technical documentation",
      files: [
        { name: "Studio Tech Setup Guide", type: "pdf" as const, size: "3.2 MB", placeholder: true },
        { name: "POS System Manual", type: "pdf" as const, size: "5.8 MB", placeholder: true },
        { name: "WiFi & Security Setup Instructions", type: "pdf" as const, size: "2.1 MB", placeholder: true },
        { name: "CRM Access Guide (GHL Credentials Flow)", type: "pdf" as const, size: "4.3 MB", placeholder: true }
      ]
    },
    sops: {
      title: "🔸 SOPs",
      description: "Technical procedures and system protocols",
      files: [
        { name: "Logging into GHL for the First Time", type: "pdf" as const, placeholder: true },
        { name: "Managing Studio Credit Transactions", type: "pdf" as const, placeholder: true },
        { name: "Setting Up Email & Domain Access", type: "pdf" as const, placeholder: true },
        { name: "Troubleshooting Common Tech Issues", type: "pdf" as const, placeholder: true }
      ]
    },
    training: {
      title: "🎓 Training",
      description: "Technical training and system education",
      files: [
        { name: "GHL Dashboard Overview", type: "mp4" as const, placeholder: true },
        { name: "Using JUV CRM Features", type: "mp4" as const, placeholder: true },
        { name: "Tech Support Escalation Process", type: "pdf" as const, placeholder: true }
      ]
    }
  };

  return (
    <KitTemplate
      kitId="technology"
      kitTitle="Technology Kit"
      kitDescription="Tools, systems, and guides to power your JUV Studio operations"
      icon={<Settings className="h-6 w-6 text-indigo-400" />}
      sections={sections}
    />
  );
};

export default TechnologyKit;
